import React, { Component } from "react";
import { states } from "../../States/States";
import styles from "../../../ricercaSegnalazioni/ricercaSegnalazioni.module.css";
import Calendar from "../../../../components/calendar/Calendar";
import stylesWelcome from "./DatiSegnalazioneAnagrafici.module.css";
import Autocomplete from "../../../../components/autocomplete/Autocomplete";
import Utils from "../../../../utils/Utils";
import { withTranslation } from "react-i18next";
import ToasterSingleton from "../../../../singleton/ToasterSingleton";
import SegnalazioniServices from "../../../../services/SegnalazioniServices";
import history from "../../../../utils/History";
import DatiAnagraficiPaziente from "./DatiAnagraficiPaziente/DatiAnagraficiPaziente";
import DatiAnagraficiMedico from "./DatiAnagraficiMedico/DatiAnagraficiMedico";
import TabellaFocolai from "./TabellaFocolai/TabellaFocolai";
import OggettiUtili from "../../../../utils/OggettiUtili.json";
import SessioneUtente from "../../../../sessionManager/SessioneUtente";
import PazientiService from "../../../../services/PazientiService";
import $ from "jquery";
import MalattieService from "../../../../services/MalattieService";
import ButtonRow from "../../../../components/ButtonRow/ButtonRow";
import SelectAutocomplete from "../../../../components/selectAutocomplete/SelectAutocomplete";
import Ruoli from "../../../../utils/Ruoli";
import MediciService from "../../../../services/MediciService";
import toasterConfig from "../../../../config/toasterConfig";
import ContactTracing from "./ContactTracing/ContactTracing";
import ContactTracingServices from "../../../../services/ContactTracingServices";
import globals from "../../../../config/appconfig";
import GestioneDuplicatiComponent from "./Components/GestioneDuplicatiComponent/GestioneDuplicatiComponent";

class DatiSegnalazioneAnagrafici extends Component {
    state = {
        datiSegnalazione: {
            timestampCompilazione: "",
            dataSegnalazione: "",
            malattia: "",
            ulssSegnalazione: "",
            comuneSegnalazione: "",
            utenteInserimento: "",
            mailInviataCorrettamente: true,
        },
        datiPaziente: {},
        formPazienteSpecifico:true,
        datiMedico: {},
        datiMedicoCopia: {},
        focolaio: {},
        sezioneForm: 0,
        malattie: JSON.parse(sessionStorage.getItem("malattie")),
        malattiePerCodice: JSON.parse(
            sessionStorage.getItem("malattiePerCodice")
        ),
        malattiaDisabled: false, //flag che disabilita la modifica delle malattie, ad esempio se ereditata da pagina di ricerca
        comuni: JSON.parse(sessionStorage.getItem("comuni")),
        comuniNascita: JSON.parse(localStorage.getItem("comuni")),
        comuniPerCodice: JSON.parse(sessionStorage.getItem("comuniPerCodice")),
        comuniPerAulss: JSON.parse(localStorage.getItem("comuniPerAulss")),
        malattiePremal : JSON.parse(sessionStorage.getItem("malattiePremal")),
        disabledConfermaProsegui: true,
        segnalazioneSalvata: {},
        segnalazioneCopia: {},
        propsPerDatiPaziente: {},
        controlloPaziente: false,
        tipoCompilazioneDatiPaziente: false,
        malattiaContactTracing:
            globals["malattie-contact-tracing"] === "string"
                ? globals["malattie-contact-tracing"].split(";")
                : globals["malattie-contact-tracing"],
        path: "",
        isAnagrafe: false,
        isPrevAnagrafe: false,
        activeFlussoGestioneDuplicati: false,
        callBackPostPaziente: null,
        timestampUltimoInvioContattiMonkeypox: null
    };

    constructor(props) {
        super(props);
        this.state.datiSegnalazione.timestampCompilazione =
            Utils.getTodayDateTimestamp();
        this.riceviValore = this.riceviValore.bind(this);
        this._validate = this._validate.bind(this);
        this._back = this._back.bind(this);
        this.selezionaComuneSegnalazione =
            this.selezionaComuneSegnalazione.bind(this);
        this.aggiungiToaster = this.aggiungiToaster.bind(this);
        this.setDatiPaziente = this.setDatiPaziente.bind(this);
        this.setTipoCompilazioneDatiPaziente =
            this.setTipoCompilazioneDatiPaziente.bind(this);
        this.setDatiMedico = this.setDatiMedico.bind(this);
        this.setDatiMedicoCopia = this.setDatiMedicoCopia.bind(this);
        this.setFocolaioSelezionato = this.setFocolaioSelezionato.bind(this);
        this.aggiungiToasterDiConferma =
            this.aggiungiToasterDiConferma.bind(this);
        this.disableData = this.disableData.bind(this);
        this.nextStep = this.nextStep.bind(this);
        this.controlloDatiToaster = this.controlloDatiToaster.bind(this);
        this.isModificaAnagrafe = this.isModificaAnagrafe.bind(this);
        this.isModificaPrevAnagrafe = this.isModificaPrevAnagrafe.bind(this);
        this.postPaziente = this.postPaziente.bind(this);
        this.setStatePadre = this.setStatePadre.bind(this);
        this.convertiInSegnalazione=this.convertiInSegnalazione.bind(this);
    }

    componentDidMount() {
        ToasterSingleton.instance().pulisci();
        ToasterSingleton.instance().sottoscrizione(this);
        this.disableData();
        
        if (this.props.ulssSegnalazione) {
            let datiSegnalazione = this.state.datiSegnalazione;
            datiSegnalazione.ulssSegnalazione =
                OggettiUtili.ulssMap[this.props.ulssSegnalazione];
            this.setState({ datiSegnalazione: datiSegnalazione });
        }else if (SessioneUtente.getInstance().ulss) {
            let codiceUlss = SessioneUtente.getInstance().ulss;
            let datiSegnalazione = this.state.datiSegnalazione;
            datiSegnalazione.ulssSegnalazione =
                OggettiUtili.ulssMap[codiceUlss];
            this.setState({ datiSegnalazione: datiSegnalazione });
        }
        if(this.props.dataSegnalazione){
            let datiSegnalazione = this.state.datiSegnalazione;
            datiSegnalazione.dataSegnalazione=this.props.dataSegnalazione;
            this.setState({ datiSegnalazione: datiSegnalazione });
        }
        if (this.props.malattia) {
            let datiSegnalazione = this.state.datiSegnalazione;
            datiSegnalazione.malattia = this.props.malattia;
            this.setState({ datiSegnalazione: datiSegnalazione });
        }
        if(this.props.comuneSegnalazione){
            let datiSegnalazione=this.state.datiSegnalazione;
            let comune=this.state.comuniPerCodice[this.props.comuneSegnalazione];
            datiSegnalazione.comuneSegnalazione=comune;
            this.setState({datiSegnalazione: datiSegnalazione});
        }
        if(this.props.focolai){
            let segnalazioneCopia = this.state.segnalazioneCopia;
            segnalazioneCopia.focolai = this.props.focolai;
            if (this.props.numeroContatti) {
                segnalazioneCopia.numeroContatti = this.props.numeroContatti
            }
            this.setState({ segnalazioneCopia: segnalazioneCopia });
        }
        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.timestampUltimoInvioContattiMonkeypox) {
            this.setState({timestampUltimoInvioContattiMonkeypox: this.props.segnalazioneCopia.timestampUltimoInvioContattiMonkeypox})
        }

        if (!Utils.isObjectEmpty(this.props.segnalazioneCopia)) {
            let datiSegnalazione = this.state.datiSegnalazione;
            datiSegnalazione.timestampCompilazione =
                this.props.segnalazioneCopia.timestampCompilazione;
            datiSegnalazione.dataSegnalazione = this.props.segnalazioneCopia
                .dataSegnalazione
                ? Utils.formatDateISO(
                      this.props.segnalazioneCopia.dataSegnalazione,
                      "/"
                  )
                : "";
            datiSegnalazione.malattia = this.props.segnalazioneCopia.malattia
                ? this.state.malattiePerCodice[
                      this.props.segnalazioneCopia.malattia
                  ].codice
                : "";
            datiSegnalazione.ulssSegnalazione = this.props.segnalazioneCopia
                .ulssSegnalazione
                ? OggettiUtili.ulssMap[
                      this.props.segnalazioneCopia.ulssSegnalazione
                  ]
                : "";
            datiSegnalazione.comuneSegnalazione = this.props.segnalazioneCopia
                .comune
                ? this.state.comuniPerCodice[
                      this.props.segnalazioneCopia.comune
                  ]
                : "";

            this.setState({ datiSegnalazione: datiSegnalazione });
        }
    }

    componentWillUnmount() {
        ToasterSingleton.instance().cancellazioneSottoscrizione();
        ToasterSingleton.instance().pulisci();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.disableData();
        if (
            !Utils.areObjectsEquivalent(
                prevProps.segnalazioneCopia,
                this.props.segnalazioneCopia
            )
        ) {
            if (this.props.segnalazioneCopia) {
                let datiSegnalazione = this.state.datiSegnalazione;
                datiSegnalazione.timestampCompilazione =
                    this.props.segnalazioneCopia.timestampCompilazione;
                datiSegnalazione.dataSegnalazione = this.props.segnalazioneCopia
                    .dataSegnalazione
                    ? Utils.formatDateISO(
                          this.props.segnalazioneCopia.dataSegnalazione,
                          "/"
                      )
                    : "";
                datiSegnalazione.malattia = this.props.segnalazioneCopia
                    .malattia
                    ? this.state.malattiePerCodice[
                          this.props.segnalazioneCopia.malattia
                      ].codice
                    : "";
                datiSegnalazione.ulssSegnalazione = this.props.segnalazioneCopia
                    .ulssSegnalazione
                    ? OggettiUtili.ulssMap[
                          this.props.segnalazioneCopia.ulssSegnalazione
                      ]
                    : "";
                datiSegnalazione.comuneSegnalazione = this.props
                    .segnalazioneCopia.comune
                    ? this.state.comuniPerCodice[
                          this.props.segnalazioneCopia.comune
                      ]
                    : "";		
                this.setState({ datiSegnalazione: datiSegnalazione });
            }
        }

        if (
            !Utils.areObjectsEquivalent(
                prevState.datiPaziente,
                this.state.datiPaziente
            )
        ) {
            let datiPaziente = this.state.datiPaziente;
            if (this.state.datiSegnalazione.malattia !== undefined) {
                datiPaziente.malattia = this.state.datiSegnalazione.malattia;
            }
            if (
                !Utils.areObjectsEquivalent(
                    prevState.datiMedico,
                    this.state.datiMedico
                )
            ) {
                this.props.updateWizardState({
                    datiPaziente: datiPaziente,
                    datiMedico: this.state.datiMedico,
                });
            } else {
                this.props.updateWizardState({ datiPaziente: datiPaziente });
            }
        }
        ToasterSingleton.instance().pulisci();
    }

    setDatiPaziente(datiPaziente) {
        this.setState({ datiPaziente: datiPaziente });
    }

    setTipoCompilazioneDatiPaziente(tipoCompilazioneDatiPaziente) {
        this.setState({
            tipoCompilazioneDatiPaziente: tipoCompilazioneDatiPaziente,
        });
    }

    setDatiMedico(datiMedico) {
        this.setState({ datiMedico: datiMedico });
    }

    setDatiMedicoCopia(datiMedicoCopia) {
        this.setState({ datiMedicoCopia: datiMedicoCopia });
    }

    setFocolaioSelezionato(focolaio) {
        let state = this.state;
        state.focolaio = focolaio;
        this.setState({ state: state });
        return this.aggiungiToasterDiConferma([
            "Segnalazione Associata corettemente al focolaio selezionato",
        ]);
    }

    _validate() {
        let { t } = this.props;

        let validateDataSegnalazione = Utils.checkDateInterval(
            this.state.datiSegnalazione.dataSegnalazione,
            "31/12/1899"
        );
        let checkTodayDataSegnalazione = Utils.checkDateLowerToday(
            this.state.datiSegnalazione.dataSegnalazione
        );
        let validateDataDiNascita = Utils.checkDateInterval(
            this.state.datiPaziente.dataDiNascita,
            "31/12/1899"
        );
        let checkTodayDataDiNascita = Utils.checkDateInterval(
            this.state.datiSegnalazione.dataSegnalazione,
            this.state.datiPaziente.dataDiNascita
        );

        if (validateDataSegnalazione) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0B_0E"]);
        } else if (checkTodayDataSegnalazione) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0B_0F"]);
        } else if (this.state.datiSegnalazione.dataSegnalazione === "") {
            let newMessaggio = Utils.replaceContentString(
                t("Messages.ERR_01_01_0B_0A"),
                "<nome campo>",
                t("DatiSegnalazioneAnagrafici.data_segnalazione")
            );
            return this.aggiungiToaster(newMessaggio);
        }

        if (validateDataDiNascita) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0B_0G"]);
        } else if (checkTodayDataDiNascita) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0B_0H"]);
        } else if (
            !this.state.datiPaziente.soggettoAnonimizzato &&
            this.state.datiPaziente.dataDiNascita === ""
        ) {
            let newMessaggio = Utils.replaceContentString(
                t("Messages.ERR_01_01_0B_0A"),
                "<nome campo>",
                t("DatiSegnalazioneAnagrafici.dataDiNascita")
            );
            return this.aggiungiToaster(newMessaggio);
        }

        if (this.state.datiPaziente.comuneNascita) {
            //verifico che il comune selezionato sia valido per quella data di nascita

            let checkComuneDataNascita =
                Utils.checkDateIntervalMinore(
                    this.state.datiPaziente.comuneNascita.dataFineValidita,
                    this.state.datiPaziente.dataDiNascita
                ) ||
                Utils.checkDateIntervalMinore(
                    this.state.datiPaziente.dataDiNascita,
                    this.state.datiPaziente.comuneNascita.dataInizioValidita
                );
            let comuneNascita = JSON.parse(
                JSON.stringify(this.state.datiPaziente.comuneNascita)
            );

            if (checkComuneDataNascita) {
                for (let i in this.state.comuniNascita) {
                    if (
                        this.state.comuniNascita[i].descrizione ===
                            this.state.datiPaziente.comuneNascita.descrizione &&
                        Utils.checkDateInterval(
                            Utils.transformDateForFrontend(
                                this.state.comuniNascita[i].dataInizioValidita
                            ),
                            this.state.datiPaziente.dataDiNascita
                        ) &&
                        Utils.checkDateInterval(
                            this.state.datiPaziente.dataDiNascita,
                            Utils.transformDateForFrontend(
                                this.state.comuniNascita[i].dataFineValidita
                            )
                        )
                    ) {
                        comuneNascita = this.state.comuniNascita[i];
                    }
                }
                //se il comuneNascita è stato aggiornato
                if (
                    !Utils.areObjectsEquivalent(
                        comuneNascita,
                        this.state.datiPaziente.comuneNascita
                    )
                ) {
                    let datiPaziente = this.state.datiPaziente;
                    datiPaziente.comuneNascita = comuneNascita;
                    this.setState({ datiPaziente: datiPaziente });
                } else {
                    let mess = Utils.replaceContentString(
                        t("Messages.ERR_COMUNE_NASCITA"),
                        "<data>",
                        this.state.datiPaziente.dataDiNascita
                    );
                    return this.aggiungiToaster([mess]);
                }
            }
        }

        if (this.state.datiPaziente.codiceFiscale) {
            if (this.state.datiPaziente.cfNonNoto) {
                return this.aggiungiToaster(t("Messages.ERR_CF_CFNONNOTO"));
            } else if (this.state.datiPaziente.stp) {
                return this.aggiungiToaster(t("Messages.ERR_CF_STP"));
            }
        }

        if (this.state.datiPaziente.stp && this.state.datiPaziente.cfNonNoto) {
            return this.aggiungiToaster(t("Messages.ERR_CFNONNOTO_STP"));
        }

        if (
            (this.state.datiPaziente.cognomePaziente &&
                this.state.datiPaziente.cognomePaziente.length < 2) ||
            (this.state.datiPaziente.nomePaziente &&
                this.state.datiPaziente.nomePaziente.length < 2)
        ) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0B_0T"]);
        }
        if (
            (this.state.datiMedico.nome &&
                this.state.datiMedico.nome.length < 2) ||
            (this.state.datiMedico.cognome &&
                this.state.datiMedico.cognome.length < 2)
        ) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0B_0U"]);
        }
        if ((this.state.datiMedico.cognome && (this.state.datiMedico.cognome.startsWith(" ") || !(/^[a-zA-Z\s'àèéìòùÀÈÉÌÒÙ]+$/.test(this.state.datiMedico.cognome))))) {
            return this.aggiungiToaster(["Messages.cognome_medico"]);
        }
        if (this.state.datiMedico.nome && (this.state.datiMedico.nome.startsWith(" ") || !(/^[a-zA-Z\s'àèéìòùÀÈÉÌÒÙ]+$/.test(this.state.datiMedico.nome)))) {
            return this.aggiungiToaster(["Messages.nome_medico"]);
        }
        if ((this.state.datiMedico.ruolo && (this.state.datiMedico.ruolo.startsWith(" ") || !(/^[a-zA-Z\s'àèéìòùÀÈÉÌÒÙ]+$/.test(this.state.datiMedico.ruolo))))) {
            return this.aggiungiToaster(["Messages.ruolo_medico"]);
        }
        if (
            this.state.datiPaziente.senzaFissaDimora &&
            this.state.datiPaziente.comuneResidenza
        ) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0B_0M"]);
        }
        if (
            this.state.datiPaziente.senzaFissaDimora &&
            this.state.datiPaziente.aslAppartenenza
        ) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0B_0N"]);
        }
        let jsonInsert = this.createJsonPaziente();

        if (
            this.props.segnalazioneCopia &&
            !Utils.isObjectEmpty(this.props.segnalazioneCopia)
        ) {
            this.putPaziente(jsonInsert);
        } else {
            this.props.setInfoMalattia(this.state.datiSegnalazione.malattia);
            this.setState({ 
                callBackPostPaziente: () => {
                    this.setState({ activeFlussoGestioneDuplicati: false })
                    this.postPaziente(jsonInsert)
                }, 
                activeFlussoGestioneDuplicati: true 
            });
        }
    }

    createJsonPaziente() {
        let datiPaziente = this.state.datiPaziente;
        let contatti = [
            {
                valore: datiPaziente.recapitoTelefonicoPaziente,
                tipo: 1,
            },
        ];

        let indirizzi = [
            {
                tipo: 1,
                comune: datiPaziente.comuneResidenza.codice,
                nazione: "",
                regione: datiPaziente.regioneResidenza.codice,
                provincia: datiPaziente.comuneResidenza.codiceProvincia,
                cap: "",
                indirizzo: datiPaziente.indirizzoResidenza,
                ulss: datiPaziente.aslAppartenenza,
            },
        ];

        indirizzi.push({
            tipo: 2,
            comune: datiPaziente.comuneDomicilio
                ? datiPaziente.comuneDomicilio.codice
                : "",
            nazione: "",
            regione: "",
            provincia: datiPaziente.comuneDomicilio
                ? datiPaziente.comuneDomicilio.codiceProvincia
                : "",
            cap: "",
            indirizzo: datiPaziente.indirizzoDomicilio
                ? datiPaziente.indirizzoDomicilio
                : "",
            ulss: datiPaziente.aslDomicilio,
        });

        let jsonInsert = {};
        jsonInsert.id = datiPaziente.idAnagrafica;
        if (datiPaziente.soggettoAnonimizzato) {
            jsonInsert.nome = "Anonimo";
            jsonInsert.cognome = "Anonimo";
        } else {
            if (
                datiPaziente.nomePaziente.startsWith(" ") ||
                datiPaziente.nomePaziente.endsWith(" ")
            ) {
                jsonInsert.nome = datiPaziente.nomePaziente.trim();
            } else {
                jsonInsert.nome = datiPaziente.nomePaziente;
            }

            if (
                datiPaziente.cognomePaziente.startsWith(" ") ||
                datiPaziente.cognomePaziente.endsWith(" ")
            ) {
                jsonInsert.cognome = datiPaziente.cognomePaziente.trim();
            } else {
                jsonInsert.cognome = datiPaziente.cognomePaziente;
            }
        }

        jsonInsert.codiceFiscale = datiPaziente.codiceFiscale;
        jsonInsert.stp = datiPaziente.stp;
        jsonInsert.cfNonNoto = datiPaziente.cfNonNoto;
        jsonInsert.dataNascita = datiPaziente.dataDiNascita
            ? Utils.transformDateForBackend(datiPaziente.dataDiNascita)
            : null;
        jsonInsert.comuneNascita = datiPaziente.comuneNascita
            ? datiPaziente.comuneNascita.codice
            : null;
        jsonInsert.cittadinanza = datiPaziente.cittadinanza
            ? datiPaziente.cittadinanza.codice
            : null;
        jsonInsert.eta = datiPaziente.eta;
        jsonInsert.etaMesi = datiPaziente.mesi;
        jsonInsert.sesso = datiPaziente.sesso;
        jsonInsert.professione = datiPaziente.professione;
        jsonInsert.indirizzi = indirizzi;
        jsonInsert.contatti = contatti;
        jsonInsert.statoEstero = datiPaziente.statoEstero;
        jsonInsert.nonInRegola = datiPaziente.nonInRegola;
        jsonInsert.senzaFissaDimora = datiPaziente.senzaFissaDimora;
        jsonInsert.codiceSsn = datiPaziente.ssn;
        jsonInsert.soggettoAnonimizzato = datiPaziente.soggettoAnonimizzato;

        return Utils.removeEmptyValueFromObject(jsonInsert);
    }

    createJsonSegnalazione(modifica, pazientId) {
        MalattieService.getInfoMalattia(this.state.datiSegnalazione.malattia)
            .then((data) => {
                if (data && data.status === 200) {
                    let focolai = [];

                    if (this.state.focolaio && this.state.focolaio.idFocolaio)
                        focolai.splice(1, 0, this.state.focolaio.idFocolaio);
                    else
                        focolai = this.props.segnalazioneCopia
                            ? this.props.segnalazioneCopia.focolai &&
                              !this.props.segnalazioneCopia.idSessioneFocolaio
                                ? this.props.segnalazioneCopia.focolai
                                : null
                            : null;

                    let ObjectForBackEnd = {};
                    ObjectForBackEnd["dataSegnalazione"] =
                        Utils.transformDateForBackend(
                            this.state.datiSegnalazione.dataSegnalazione
                        );
                    ObjectForBackEnd["timestampCompilazione"] =
                        this.state.datiSegnalazione.timestampCompilazione;
                    ObjectForBackEnd["malattia"] =
                        this.state.datiSegnalazione.malattia;
                    ObjectForBackEnd["comune"] =
                        this.state.datiSegnalazione.comuneSegnalazione.codice;
                    ObjectForBackEnd["ulssSegnalazione"] =
                        this.state.datiSegnalazione.ulssSegnalazione.codice;
                    ObjectForBackEnd["focolai"] = focolai;
                    ObjectForBackEnd["casoZero"] =
                        this.props.segnalazioneCopia.casoZero === true ||
                        this.props.segnalazioneCopia.casoZero === false
                            ? this.props.segnalazioneCopia.casoZero
                            : null;
                    ObjectForBackEnd["ulssAppartenenza"] =
                        this.state.datiPaziente.aslDomicilio;
                    ObjectForBackEnd["ulssResidenza"] =
                        this.state.datiPaziente.aslAppartenenza;
                    ObjectForBackEnd["pazienteId"] =
                        pazientId ?? this.state.datiPaziente.idAnagrafica;
                    ObjectForBackEnd["eta"] = this.state.datiPaziente.eta;
                    ObjectForBackEnd["mesi"] = this.state.datiPaziente.mesi;
                    ObjectForBackEnd["sesso"] = this.state.datiPaziente.sesso;
                    ObjectForBackEnd["medicoId"] =
                        this.state.datiMedico.idMedico;

                    ObjectForBackEnd["utenteInserimento"] =
                        this.props.segnalazioneCopia &&
                        this.props.segnalazioneCopia.utenteInserimento
                            ? this.props.segnalazioneCopia.utenteInserimento
                            : SessioneUtente.getInstance().nomeUtente +
                              " " +
                              SessioneUtente.getInstance().cognomeUtente;
                    ObjectForBackEnd["idOperatore"] =
                        this.props.segnalazioneCopia &&
                        this.props.segnalazioneCopia.idOperatore
                            ? this.props.segnalazioneCopia.idOperatore
                            : SessioneUtente.getInstance().codiceFiscale;

                    ObjectForBackEnd["statoValidazione"] = "00"; //mockup
                    ObjectForBackEnd["schedaSpecialePresente"] = !!(
                        data.data.schedaSpeciale &&
                        data.data.schedaSpeciale.idSchedaSpeciale
                    );
                    ObjectForBackEnd["idLisSegnalazione"]=this.props.idLisSegnalazione;
                    if (
                        modifica &&
                        (this.state.malattiaContactTracing === "true" ||
                            this.state.malattiaContactTracing?.includes(
                                this.props.malattia ??
                                    this.props.segnalazioneCopia.malattia
                            ))
                    ) {
                        // se l'array è pieno è sempre true
                        ContactTracingServices.getNumeroContatti(
                            this.props.segnalazioneCopia.idSegnalazione
                        )
                            .then((data2) => {
                                if (data2 && data2.status === 200) {
                                    ObjectForBackEnd["numeroContatti"] =
                                        data2.data ? data2.data : null;
                                }

                                let oggettoPulito =
                                    Utils.removeEmptyValueFromObject(
                                        ObjectForBackEnd
                                    );
                                this.putSegnalazione(oggettoPulito);
                            })
                            .catch((reason) => {
                                this.props.showSpinner(false);
                                console.log(
                                    "[ERROR] get Numero Contatti Contact Tracing: " +
                                        reason
                                );
                            });
                    } else {
                        let oggettoPulito =
                            Utils.removeEmptyValueFromObject(ObjectForBackEnd);
                        if (modifica) {
                            this.putSegnalazione(oggettoPulito);
                        } else {
                            this.postSegnalazione(oggettoPulito);
                        }
                    }
                }
            })
            .catch((reason) => {
                this.props.showSpinner(false);
                console.log("[ERROR] post inserimento paziente: " + reason);
            });
    }

    putPaziente(jsonInsert) {
        this.props.showSpinner(true);
        let pazienteId = "";
        if (this.props.segnalazione.pazienteId) {
            jsonInsert.id = this.props.segnalazione.pazienteId;
            pazienteId = this.props.segnalazione.pazienteId;
        }

        if (this.state.isPrevAnagrafe || this.state.isAnagrafe) {
            jsonInsert.id = this.state.datiPaziente.idAnagrafica;
            if (jsonInsert.id === pazienteId) {
                jsonInsert.id = null;
            }
            PazientiService.putModificaPazienteAnagrafe(pazienteId, jsonInsert)
                .then((data) => {
                    console.log("post inserimento paziente corretta");
                    let datiPaziente = this.state.datiPaziente;
                    if (datiPaziente.soggettoAnonimizzato) {
                        datiPaziente.nomePaziente = "ANONIMO";
                        datiPaziente.cognomePaziente = "ANONIMO";
                    }
                    datiPaziente.idAnagrafica = data.data.idPaziente;
                    this.setState({ datiPaziente: datiPaziente });
                    if (this.state.datiMedico.idMedico) {
                        if (
                            this.state.datiMedico &&
                            this.state.datiMedicoCopia &&
                            !Utils.areObjectsEquivalent(
                                this.state.datiMedico,
                                this.state.datiMedicoCopia
                            )
                        ) {
                            //put
                            let datiMedico = {};
                            datiMedico["recapitoTelefonico"] =
                                this.state.datiMedico.recapitoTelefonico;
                            datiMedico["fax"] = this.state.datiMedico.fax;
                            datiMedico["email"] = this.state.datiMedico.email;
                            datiMedico["nome"] =
                                this.state.datiMedico.nome.trim();
                            datiMedico["cognome"] =
                                this.state.datiMedico.cognome.trim();
                            datiMedico["ruolo"] = this.state.datiMedico.ruolo;
                            this.putMedico(
                                this.state.datiMedico.idMedico,
                                datiMedico,
                                true
                            );
                        } else {
                            this.createJsonSegnalazione(true);
                        }
                    } else {
                        this.postMedico(this.state.datiMedico, true);
                    }
                })
                .catch((reason) => {
                    this.props.showSpinner(false);
                    console.log("[ERROR] post inserimento paziente: " + reason);
                });
        } else {
            PazientiService.putInserimentoPaziente(jsonInsert)
                .then((data) => {
                    console.log("post inserimento paziente corretta");
                    if (this.state.datiMedico.idMedico) {
                        if (
                            this.state.datiMedico &&
                            this.state.datiMedicoCopia &&
                            !Utils.areObjectsEquivalent(
                                this.state.datiMedico,
                                this.state.datiMedicoCopia
                            )
                        ) {
                            //put
                            let datiMedico = {};
                            datiMedico["recapitoTelefonico"] =
                                this.state.datiMedico.recapitoTelefonico;
                            datiMedico["fax"] = this.state.datiMedico.fax;
                            datiMedico["email"] = this.state.datiMedico.email;
                            datiMedico["nome"] =
                                this.state.datiMedico.nome.trim();
                            datiMedico["cognome"] =
                                this.state.datiMedico.cognome.trim();
                            datiMedico["ruolo"] = this.state.datiMedico.ruolo;
                            this.putMedico(
                                this.state.datiMedico.idMedico,
                                datiMedico,
                                true
                            ); // viene passato true se si tratta put segnalazione altrimenti false per post segnalazione
                        } else {
                            this.createJsonSegnalazione(true, pazienteId);
                        }
                    } else {
                        //post
                        this.postMedico(this.state.datiMedico, true);
                    }
                })
                .catch((reason) => {
                    this.props.showSpinner(false);
                    console.log("[ERROR] post inserimento paziente: " + reason);
                });
        }
    }

    postPaziente(jsonInsert) {
        this.props.showSpinner(true);
        if (
            !this.state.tipoCompilazioneDatiPaziente &&
            !this.state.datiPaziente.soggettoAnonimizzato
        ) {
            let params = {
                ulss: "050508",
                nome: this.state.datiPaziente.nomePaziente,
                cognome: this.state.datiPaziente.cognomePaziente,
                codiceFiscale: this.state.datiPaziente.codiceFiscale,
                dataNascita: Utils.transformDateForBackend(
                    this.state.datiPaziente.dataDiNascita
                ),
            };
            PazientiService.getPazienti(params)
                .then((data) => {
                    if (
                        data.data.anagraficaRicercaDTOList &&
                        data.data.anagraficaRicercaDTOList.length > 0
                    ) {
                        let res = Utils.mapGetPaziente(
                            data,
                            Utils.transformTimeStampForFrontend(
                                this.state.datiSegnalazione
                                    .timestampCompilazione
                            )
                        );
                        let propsPerDatiPaziente = {
                            rowsTabPaziente: res,
                            showTablePaziente: true,
                            totalElementsTabPaziente: res.length,
                            disabled: false,
                            disableSoggetto: true,
                        };
                        this.setState({
                            propsPerDatiPaziente: propsPerDatiPaziente,
                            datiPaziente: {},
                        });
                        this.props.showSpinner(false);
                        return this.aggiungiToaster([
                            "Messages.ERR_01_01_0B_0D",
                        ]);
                    } else {
                        this.callAnagraficaPerInserimentoPaziente(jsonInsert);
                    }
                })
                .catch(() => {
                    this.callAnagraficaPerInserimentoPaziente(jsonInsert);
                });
        } else {
            this.callAnagraficaPerInserimentoPaziente(jsonInsert);
        }
    }

    callAnagraficaPerInserimentoPaziente(jsonInsert) {
        PazientiService.postInserimentoPaziente(jsonInsert)
            .then((data) => {
                console.log("post inserimento paziente corretta");
                let datiPaziente = this.state.datiPaziente;
                if (datiPaziente.soggettoAnonimizzato) {
                    datiPaziente.nomePaziente = "ANONIMO";
                    datiPaziente.cognomePaziente = "ANONIMO";
                }
                datiPaziente.idAnagrafica = data.data.idPaziente;
                this.setState({ datiPaziente: datiPaziente });
                if (this.state.datiMedico.idMedico) {
                    if (
                        this.state.datiMedico &&
                        this.state.datiMedicoCopia &&
                        !Utils.areObjectsEquivalent(
                            this.state.datiMedico,
                            this.state.datiMedicoCopia
                        )
                    ) {
                        //put
                        let datiMedico = {};
                        datiMedico["recapitoTelefonico"] =
                            this.state.datiMedico.recapitoTelefonico;
                        datiMedico["fax"] = this.state.datiMedico.fax;
                        datiMedico["email"] = this.state.datiMedico.email;
                        datiMedico["nome"] = this.state.datiMedico.nome.trim();
                        datiMedico["cognome"] =
                            this.state.datiMedico.cognome.trim();
                        datiMedico["ruolo"] = this.state.datiMedico.ruolo;
                        this.putMedico(
                            this.state.datiMedico.idMedico,
                            datiMedico
                        );
                    } else {
                        this.createJsonSegnalazione(false);
                    }
                } else {
                    //post
                    this.postMedico(this.state.datiMedico);
                }
            })
            .catch((reason) => {
                this.props.showSpinner(false);
                console.log("[ERROR] post inserimento paziente: " + reason);
            });
    }

    postMedico(jsonInsert, modifica) {
        jsonInsert.nome = jsonInsert.nome.trim();
        jsonInsert.cognome = jsonInsert.cognome.trim();
        this.props.showSpinner(true);
        MediciService.postInserimentoMedico(jsonInsert)
            .then((data) => {
                console.log("post inserimento medico corretta");
                let datiMedico = this.state.datiMedico;
                datiMedico.idMedico = data.data.idMedico;
                this.setState({ datiMedico: datiMedico });
                this.createJsonSegnalazione(modifica);
            })
            .catch((reason) => {
                this.props.showSpinner(false);
                console.log("[ERROR] post inserimento medico: " + reason);
            });
    }

    putMedico(idMedico, jsonInsert, modifica) {
        this.props.showSpinner(true);
        MediciService.putInserimentoMedico(idMedico, jsonInsert)
            .then(() => {
                console.log("post inserimento medico corretta");
                let datiMedico = this.state.datiMedico;
                this.setState({ datiMedico: datiMedico });
                this.createJsonSegnalazione(modifica);
            })
            .catch((reason) => {
                this.props.showSpinner(false);
                console.log("[ERROR] put aggiorna medico: " + reason);
            });
    }

    putSegnalazione(jsonInsert) {
        jsonInsert["idSegnalazione"] =
            this.props.segnalazioneCopia.idSegnalazione;
        jsonInsert["statoSegnalazione"] =
            this.props.segnalazioneCopia.statoSegnalazione;
        jsonInsert["datiSanitari"] = this.props.segnalazioneCopia.datiSanitari;
        jsonInsert["infoCliniche"] = this.props.segnalazioneCopia.infoCliniche;
        jsonInsert["infoEpidemiologiche"] =
            this.props.segnalazioneCopia.infoEpidemiologiche;
        jsonInsert["infoLaboratorio"] =
            this.props.segnalazioneCopia.infoLaboratorio;
        jsonInsert["esito"] = this.props.segnalazioneCopia.esito;
        jsonInsert["datiSpecifici"] =
            this.props.segnalazioneCopia.datiSpecifici;
        if (
            this.props.segnalazioneCopia &&
            this.props.segnalazioneCopia.schedaSpeciale
        ) {
            jsonInsert["schedaSpeciale"] =
                this.props.segnalazioneCopia.schedaSpeciale;
        }
        if (
            this.props.segnalazioneCopia &&
            this.props.segnalazioneCopia.esitoTbcPolmonare
        ) {
            jsonInsert["esitoTbcPolmonare"] =
                this.props.segnalazioneCopia.esitoTbcPolmonare;
        }
        if (
            this.props.segnalazioneCopia &&
            this.props.segnalazioneCopia.idPdf
        ) {
            jsonInsert["idPdf"] = this.props.segnalazioneCopia.idPdf;
        }
        if (
            this.props.segnalazioneCopia &&
            this.props.segnalazioneCopia.pdfAssociato
        ) {
            jsonInsert["pdfAssociato"] =
                this.props.segnalazioneCopia.pdfAssociato;
        }
        if (
            this.props.segnalazioneCopia &&
            this.props.segnalazioneCopia.pdfInviato
        ) {
            jsonInsert["pdfInviato"] = this.props.segnalazioneCopia.pdfInviato;
        }
        if (
            this.props.segnalazioneCopia &&
            this.props.segnalazioneCopia.mailInviataCorrettamente
        ) {
            jsonInsert["mailInviataCorrettamente"] =
                this.props.segnalazioneCopia.pdfInviato;
        }
        if (
            this.state &&
            this.state.timestampUltimoInvioContattiMonkeypox
        ) {
            jsonInsert["timestampUltimoInvioContattiMonkeypox"] =
                this.state.timestampUltimoInvioContattiMonkeypox;
        }
        jsonInsert["schedaSpecialePresente"] =
            this.props.infoMalattia.schedaSpeciale &&
            this.props.infoMalattia.schedaSpeciale.idSchedaSpeciale
                ? true
                : false;
        for (let i = 0; i < this.state.malattie.length; i++) {
            if (
                this.state.malattie[i].codice ===
                this.state.datiSegnalazione.malattia
            ) {
                jsonInsert["giorniValidita"] =
                    this.state.malattie[i].giorniValidita;
            }
        }

        if (this.state.malattiePremal["giornaliero"].includes(this.state.datiSegnalazione.malattia) || this.state.malattiePremal["settimanale"].includes(this.state.datiSegnalazione.malattia)) {
            if (this.props.segnalazioneCopia) {
                jsonInsert["idoneitaPremal"] = Utils.retrieveIdoneitaPremal(
                    this.props.segnalazioneCopia,
                    this.state.datiPaziente,
                    this.state.datiMedico
                );
            } else {
                let idoneitaPremal = {}
                idoneitaPremal["idoneita"] = false;
                jsonInsert["idoneitaPremal"] = idoneitaPremal;
            }
        }

        let jsonInsertPulito = Utils.removeEmptyValueFromObject(jsonInsert);

        SegnalazioniServices.putModificaSegnalazionePrimoStep(
            jsonInsertPulito,
            this.props.segnalazione.idSegnalazione
        )
            .then((data) => {
                let path = "/wizardSegnalazione";
                this.props.showSpinner(false);
                if (data && data.status === 200) {
                    let segnalazioneSalvata = Utils.removeFieldFromObject(
                        data.data.segnalazione,
                        "_id"
                    );
                    let datiPaziente = this.state.datiPaziente;
                    let datiMedico = this.state.datiMedico;
                    datiPaziente.malattia =
                        this.state.datiSegnalazione.malattia;
                    this.nextStep(
                        path,
                        segnalazioneSalvata,
                        segnalazioneSalvata,
                        datiPaziente,
                        datiMedico
                    );
                } else {
                    console.log("errori");
                }
            })
            .catch((reason) => {
                this.props.showSpinner(false);
                console.log("[ERROR] put segnalazioni");
            });
    }

    postSegnalazione(jsonInsert) {
        this.props.showSpinner(true);
        MalattieService.getInfoMalattia(this.state.datiSegnalazione.malattia)
            .then((data) => {
                if (data && data.status === 200) {
                    if (
                        data.data &&
                        data.data.schedaSpeciale &&
                        data.data.schedaSpeciale.idSchedaSpeciale
                    ) {
                        jsonInsert["schedaSpecialePresente"] = true;
                    } else {
                        jsonInsert["schedaSpecialePresente"] = false;
                    }
                    for (let i = 0; i < this.state.malattie.length; i++) {
                        if (
                            this.state.malattie[i].codice ===
                            this.state.datiSegnalazione.malattia
                        ) {
                            jsonInsert["giorniValidita"] =
                                this.state.malattie[i].giorniValidita;
                        }
                    }

                    if (this.state.malattiePremal["giornaliero"].includes(this.state.datiSegnalazione.malattia) || this.state.malattiePremal["settimanale"].includes(this.state.datiSegnalazione.malattia)) {
                        let idoneitaPremal = {};
                        idoneitaPremal["idoneita"] = false;
                        jsonInsert["idoneitaPremal"] = idoneitaPremal;
                    }

                    if (
                        this.state &&
                        this.state.timestampUltimoInvioContattiMonkeypox
                    ) {
                        jsonInsert["timestampUltimoInvioContattiMonkeypox"] =
                            this.state.timestampUltimoInvioContattiMonkeypox;
                    }

                    SegnalazioniServices.postInserimentoSegnalazione(jsonInsert)
                        .then((data) => {
                            this.props.showSpinner(false);
                            if (data && data.status === 200) {
                                let path = "/wizardSegnalazione";
                                let segnalazioneSalvata = jsonInsert;
                                segnalazioneSalvata["idSegnalazione"] =
                                    data.data.idSegnalazione;
                                segnalazioneSalvata["statoSegnalazione"] =
                                    OggettiUtili.statoSegnalazioneByLabel.Bozza.codice;
                                let datiPaziente = this.state.datiPaziente;
                                let datiMedico = this.state.datiMedico;
                                datiPaziente.malattia = this.state.datiSegnalazione.malattia;
                                console.log("Chiamata al BE senza errori");
                                console.log(data.data);
                                let state = this.state;
                                state.datiPaziente = datiPaziente;
                                state.datiMedico = datiMedico;
                                state.segnalazioneCopia = segnalazioneSalvata;
                                state.path = path;
                                state.mailInviataCorrettamente = data.data.mailInviataCorrettamente ? data.data.mailInviataCorrettamente : null;
                                this.setState({ state: state });
                                this.nextStep(
                                    path,
                                    segnalazioneSalvata,
                                    segnalazioneSalvata,
                                    datiPaziente,
                                    datiMedico
                                );
                            } else {
                                console.log("[ERROR] post segnalazioni");
                            }
                        })
                        .catch((reason) => {
                            this.props.showSpinner(false);
                            console.log("[ERROR] put segnalazioni");
                        });
                }
            })
            .catch((reason) => {
                console.log("[ERROR] post inserimento paziente: " + reason);
            });
    }

    aggiungiToaster(text, tipo, textList) {
        ToasterSingleton.instance().aggiuntaToaster({
            type:
                tipo && tipo === 1
                    ? toasterConfig.types.successo
                    : toasterConfig.types.confirm,
            text: text,
            timestamp: Date.now(),
            textList: textList,
        });
    }

    aggiungiToasterDiConferma(text) {
        ToasterSingleton.instance().aggiuntaToaster({
            type: toasterConfig.types.informational,
            text: text,
            timestamp: Date.now(),
        });
    }

    _back() {
        let path = "/ricercaSegnalazioni";
        history.push({ pathname: path });
    }

    selezionaComuneSegnalazione(object) {
        let segnalazione = this.state.datiSegnalazione;
        segnalazione.comuneSegnalazione = object;
        this.setState({ datiSegnalazione: segnalazione });
    }

    riceviValore(field, event) {
        let segnalazione = this.state.datiSegnalazione;

        if (field == "malattia") {
            segnalazione.malattia = event.target.value;
            this.props.setMalattia(event.target.value);
        } else if (field == "ulssSegnalazione") {
            segnalazione.ulssSegnalazione = event.target.value;
            segnalazione.comuneSegnalazione = "";
        } else if (field == "comuneSegnalazione") {
            segnalazione.comuneSegnalazione = event.target.value;
        } else if (field.currentTarget) {
            if (field.currentTarget.id == "dataSegnalazione") {
                segnalazione.dataSegnalazione = field.target.value;
            } else if (field.currentTarget.id == "timestampCompilazione") {
                segnalazione.timestampCompilazione = field.target.value;
            }
        }

        this.setState({ datiSegnalazione: segnalazione });
    }

    controlloDatiToaster() {
        let textList = [];
        if (!this.state.datiSegnalazione.malattia)
            textList.push('Campo "Malattia" mancante');
        if (!this.state.datiSegnalazione.comuneSegnalazione)
            textList.push('Campo "Comune di segnalazione" mancante');
        if (!this.state.datiSegnalazione.ulssSegnalazione)
            textList.push('Campo "Ulss di segnalazione" mancante');
        if (!this.state.datiSegnalazione.timestampCompilazione)
            textList.push('Campo "Data Compilazione" mancante');
        if (
            !this.state.datiSegnalazione.dataSegnalazione ||
            Utils.isDateInValid(
                Utils.transformDateForBackend(
                    this.state.datiSegnalazione.dataSegnalazione
                ),
                "-"
            )
        )
            textList.push('Campo "Data Segnalazione" mancante');
        if (
            !this.state.datiPaziente.soggettoAnonimizzato &&
            !this.state.datiPaziente.nomePaziente
        )
            textList.push('Campo "Nome" mancante');
        if (
            !this.state.datiPaziente.soggettoAnonimizzato &&
            !this.state.datiPaziente.cognomePaziente
        )
            textList.push('Campo "Cognome" mancante');
        if (this.state.datiPaziente.eta === "")
            textList.push('Campi "Anni e Mesi" mancanti');
        if (
            !this.state.datiPaziente.dataDiNascita ||
            Utils.isDateInValid(
                Utils.transformDateForBackend(
                    this.state.datiPaziente.dataDiNascita
                ),
                "-"
            )
        )
            textList.push('Campo "Data di nascita" mancante')
        else if (Utils.checkDateInterval(this.state.datiPaziente.dataDiNascita, "31/12/1908"))
            textList.push('Campo "Data di nascita" inferiore al 01/01/1909')
        if (!this.state.datiPaziente.sesso)
            textList.push('Campo "Sesso" mancante');
        if (
            !this.state.datiPaziente.soggettoAnonimizzato &&
            !this.state.datiPaziente.codiceFiscale &&
            !this.state.datiPaziente.stp &&
            !this.state.datiPaziente.cfNonNoto
        )
            textList.push(
                'Uno tra i campi "Codice Fiscale - CF non noto - Numero Identificativo Personale/STP" mancante'
            );
        if (!this.state.datiPaziente.comuneNascita)
            textList.push(
                'Campo "Comune (o Stato Estero) di nascita" mancante'
            );
        if (!this.state.datiPaziente.professione)
            textList.push('Campo "Professione" mancante');
        if (!this.state.datiPaziente.cittadinanza)
            textList.push('Campo "Cittadinanza" mancante');
        if (!this.state.datiPaziente.senzaFissaDimora && !this.state.datiPaziente.comuneResidenza)
            textList.push('Campo "Comune (o Stato Estero) residenza" mancante');
        if(this.state.datiPaziente.comuneResidenza && !(this.state.datiPaziente.comuneResidenza.codice.includes("Z")) && !this.state.datiPaziente.regioneResidenza)
            textList.push('Campo "Comune (o Stato Estero) residenza" valorizzato con comune italiano ma il campo "Regione" mancante');
        if(this.state.datiPaziente.comuneResidenza && !(this.state.datiPaziente.comuneResidenza.codice.includes("Z")) && !this.state.datiPaziente.provinciaResidenza)
            textList.push('Campo "Comune (o Stato Estero) residenza" valorizzato con comune italiano ma il campo "Provincia" mancante');
        if (
            !this.state.datiPaziente.soggettoAnonimizzato &&
            this.state.datiPaziente.codiceFiscale &&
            !Utils.isCFValid(this.state.datiPaziente.codiceFiscale)
        )
            textList.push('Campo "Codice fiscale" non corretto');
        if (
            !this.state.datiPaziente.aslAppartenenza &&
            !this.state.datiPaziente.senzaFissaDimora &&
            this.state.datiPaziente.comuneResidenza
        )
            textList.push(
                'Campo "Comune (o Stato Estero) residenza" valorizzato ma il campo "Ulss residenza" mancante'
            );
        if (
            this.state.datiPaziente.comuneResidenza &&
            !this.state.datiPaziente.indirizzoResidenza
        )
            textList.push(
                'Campo "Comune (o Stato Estero) residenza" valorizzato ma il campo "Indirizzo residenza" mancante'
            );
        if (!this.state.datiMedico.nome) textList.push('Campo "Nome" mancante');
        if (!this.state.datiMedico.cognome)
            textList.push('Campo "Cognome" mancante');
        if (!this.state.datiMedico.ruolo)
            textList.push('Campo "Ruolo/Specialità" mancante');

        if (textList.length > 0)
            return this.aggiungiToaster(
                textList,
                toasterConfig.types.confirm,
                true
            );
        else {
            if (
                (this.props.segnalazione &&
                    this.props.segnalazione.migrazione) ||
                SessioneUtente.getInstance().ruoliUtente ===
                    Ruoli.Operatore_Laboratorio.descrizione ||
                (this.props.segnalazioneCopia &&
                    (this.props.segnalazioneCopia.statoSegnalazione ===
                        OggettiUtili.statoSegnalazioneByLabel.Archiviato
                            .codice ||
                        this.props.segnalazioneCopia.statoValidazione ===
                            OggettiUtili.statoValidazioneByLabel.Validata
                                .codice))
            ) {
                this.nextStep(
                    "/wizardSegnalazione",
                    this.props.segnalazioneCopia,
                    this.props.segnalazioneCopia,
                    this.state.datiPaziente,
                    this.state.datiMedico
                );
            } else {
                this._validate();
            }
        }
    }

    isModificaAnagrafe(isAnagrafe) {
        this.setState({ isAnagrafe: isAnagrafe });
    }

    isModificaPrevAnagrafe(isAnagrafe) {
        this.setState({ isPrevAnagrafe: isAnagrafe });
    }

    disableData() {
        if (Utils.isEmpty(this.props.segnalazioneCopia)) {
            $(document).ready(function () {
                $("#dataSegnalazione").datepicker("enable");
                $("#timestampCompilazione").datepicker("disable");
            });
        } else {
            $(document).ready(function () {
                $("#timestampCompilazione").datepicker("disable");
                $("#dataSegnalazione").datepicker("disable");
            });
        }
    }

    nextStep(path, segnalazione, segnalazioneCopia, datiPaziente, datiMedico) {
        history.push({
            pathname: path,
            state: {
                currentState: states.DATI_SANITARI,
                segnalazione: segnalazione,
                segnalazioneCopia: segnalazioneCopia,
                datiCompletiECorretti:
                    Utils.getCompletezzaStep(segnalazioneCopia),
                datiPaziente: datiPaziente ? datiPaziente : null,
                datiMedico: datiMedico ? datiMedico : null,
            },
        });
    }

    setStatePadre(state) {
        this.setState(state)
    }

    convertiInSegnalazione(row){
        let path = "/convertiSegnalazione";
        history.push({
            pathname: path,
            props:{
                path: "/wizardSegnalazione",
                malattia: "0578",
                nomePaziente: row.nome,
                cognomePaziente: row.cognome,
                dataDiNascita: row.dataNascita,
                focolai: this.props.segnalazioneCopia.focolai
            }
        });
    }

    render() {
        const { t } = this.props;

        let arrayUlss = Utils.getArrayUlss();

        let listaComuni = [];
        if (
            this.state.datiSegnalazione.ulssSegnalazione &&
            this.state.datiSegnalazione.ulssSegnalazione.codice
        ) {
            listaComuni =
                this.state.comuniPerAulss[
                    this.state.datiSegnalazione.ulssSegnalazione.codice
                ];
        } else {
            listaComuni = this.state.comuni;
        }

        const malattieDaEliminare = [
            "MALATTIA BATTERICO INVASIVA DA STREPTOCOCCUS PYOGENES",
            "MENINGITE DA BATTERI NON SPECIFICATI",
            "MENINGITE DA CRIPTOCOCCO",
            "MENINGITE DA LEPTOSPIRA",
            "MENINGITE DA TRIPANOSOMA",
            "MENINGITE SIFILITICA",
            "MENINGITE STAFILOCOCCICA",
            "MENINGITE STREPTOCOCCICA",
            "MENINGITE DA PNEUMOCOCCO (S.Pneumoniae)",
            "MENINGITE MENINGOCOCCO (N.Meningitidis)",
            "MENINGITE DA EMOFILO (H.Influenzae)",
            "MALATTIA BATTERICO INVASIVA DA STAPHYLOCOCCUS CAPITIS",
            "MALATTIA BATTERICO INVASIVA CON AGENTE IN ATTESA DI IDENTIFICAZIONE",
            "MALATTIA BATTERICO INVASIVA DA AGENTE NON IDENTIFICATO",
            "MALATTIA BATTERICO INVASIVA DA ALTRI AGENTI",
            "MALATTIA BATTERICO INVASIVA DA ALTRI BATTERI GRAM-",
            "MALATTIA BATTERICO INVASIVA DA ENTEROCOCCUS FAECALIS",
            "MALATTIA BATTERICO INVASIVA DA ESCHERICHIA COLI",
            "MALATTIA BATTERICO INVASIVA DA EMOFILO (H.Influenzae)",
            "MALATTIA BATTERICO INVASIVA DA KLEBSIELLA PNEUMONIAE",
            "MALATTIA BATTERICO INVASIVA DA KLEBSIELLA SPP",
            "MALATTIA BATTERICO INVASIVA DA LEPTOSPIRA SPP",
            "MALATTIA BATTERICO INVASIVA DA LISTERIA MONOCYTOGENES",
            "MALATTIA BATTERICO INVASIVA DA MYCOBACTERIUM TUBERCOLISIS",
            "MALATTIA BATTERICO INVASIVA DA MENINGOCOCCO (N.Meningitidis)",
            "MALATTIA BATTERICO INVASIVA DA PSEUDOMONAS AERUGINOSA",
            "MALATTIA BATTERICO INVASIVA DA STAPHYLOCOCCUS AUREUS",
            "MALATTIA BATTERICO INVASIVA DA STREPTOCOCCUS B",
            "MALATTIA BATTERICO INVASIVA DA PNEUMOCOCCO (S.Pneumoniae)"
        ];

        this.state.malattie = this.state.malattie.filter(malattia =>
            !malattieDaEliminare.includes(malattia.descrizione)
        );

        const datiSegnalazione = (
            <div>
                {this.props.segnalazione?.idoneitaPremal?.idoneita === false ?
                    <div className="row">
                        <div class="col-xl-9">
                            <h6>Attenzione - Per l'effettivo inserimento della segnalazione è necessario che le prime
                                tre
                                sezioni vengano compilate</h6>
                        </div>
                        <div class="col-xl-3">
                            <h6 className={styles.msgIdoneitaPremal}>
                                La segnalazione non è idonea per l'invio a Premal
                            </h6>
                        </div>
                    </div> :
                    <h6>Attenzione - Per l'effettivo inserimento della segnalazione è necessario che le prime tre
                        sezioni vengano compilate</h6>
                }
                <h6>{t("DatiSegnalazioneAnagrafici.datiSegnalazione")}</h6>
                <hr className={stylesWelcome.hr}></hr>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 mt-1">
                            <div className="row">
                                <div className="col-lg-4">
                                    <p
                                        className={styles.labelHeader}
                                        style={{
                                            color: "#1b7ea9",
                                            marginTop: "10px",
                                        }}
                                    >
                                        {t(
                                            "DatiSegnalazioneAnagrafici.dataCompilazione"
                                        )}
                                        <span className={styles.mandatoryColor}>
                                            *
                                        </span>
                                    </p>
                                </div>
                                <div className="col-lg-8">
                                    <Calendar
                                        id={"timestampCompilazione"}
                                        value={Utils.transformTimeStampForFrontend(
                                            this.state.datiSegnalazione
                                                .timestampCompilazione
                                        )}
                                        field={"timestampCompilazione"}
                                        disabled={true}
                                        errorMessage={"data non valida"}
                                        error={
                                            this.state.datiSegnalazione
                                                .timestampCompilazione == "" ||
                                            this.state.datiSegnalazione
                                                .timestampCompilazione == null
                                        }
                                    ></Calendar>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ marginTop: "5px" }}>
                        <div className="col-lg-7  mt-3">
                            <div className="row">
                                <div className="col-lg-4">
                                    <p
                                        className={styles.labelHeader}
                                        style={{
                                            color: "#1b7ea9",
                                            marginTop: "10px",
                                        }}
                                    >
                                        {t(
                                            "DatiSegnalazioneAnagrafici.data_segnalazione"
                                        )}
                                        <span className={styles.mandatoryColor}>
                                            *
                                        </span>
                                    </p>
                                </div>
                                <div className="col-lg-8">
                                    <Calendar
                                        id={"dataSegnalazione"}
                                        value={
                                            this.state.datiSegnalazione
                                                .dataSegnalazione
                                        }
                                        field={"dataSegnalazione"}
                                        onChange={this.riceviValore}
                                        disabled={
                                            Utils.isEmpty(
                                                this.props.segnalazioneCopia
                                            )
                                                ? false
                                                : true
                                        }
                                        errorMessage={Utils.replaceContentString(
                                            t("Messages.ERR_01_01_0B_0A"),
                                            "<nome campo>",
                                            t(
                                                "DatiSegnalazioneAnagrafici.data_segnalazione"
                                            )
                                        )}
                                        error={
                                            this.state.datiSegnalazione
                                                .dataSegnalazione == "" ||
                                            this.state.datiSegnalazione
                                                .dataSegnalazione == null
                                                ? false
                                                : Utils.isDateInValid(
                                                      Utils.transformDateForBackend(
                                                          this.state
                                                              .datiSegnalazione
                                                              .dataSegnalazione
                                                      ),
                                                      "-"
                                                  )
                                        }
                                    ></Calendar>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ marginTop: "5px" }}>
                        <div className="col-lg-7 mt-3">
                            <div className="row">
                                <div className="col-lg-4">
                                    <p
                                        className={styles.labelHeader}
                                        style={{
                                            color: "#1b7ea9",
                                            marginTop: "10px",
                                        }}
                                    >
                                        {t(
                                            "DatiSegnalazioneAnagrafici.malattia"
                                        )}
                                        <span className={styles.mandatoryColor}>
                                            *
                                        </span>
                                    </p>
                                </div>
                                <div className="col-lg-8">
                                    <div
                                        className={stylesWelcome.fieldContainer}
                                    >
                                        <SelectAutocomplete
                                            id={"idMalattia"}
                                            onChange={this.riceviValore}
                                            newSelect={true}
                                            field={"malattia"}
                                            value={
                                                this.state.datiSegnalazione
                                                    .malattia
                                            }
                                            functionMap={Utils.mapToArray(
                                                this.state.malattie
                                            ).map((oggetto) => {
                                                return (
                                                    <option
                                                        value={oggetto.codice}
                                                    >
                                                        {oggetto.descrizione}
                                                    </option>
                                                );
                                            })}
                                            disabled={
                                                !Utils.isEmpty(
                                                    this.props.segnalazioneCopia
                                                ) || this.props.malattia
                                                    ? true
                                                    : false
                                            }
                                        ></SelectAutocomplete>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-7 mt-3">
                            <div className="row">
                                <div className="col-lg-4">
                                    <p
                                        className={styles.labelHeader}
                                        style={{
                                            color: "#1b7ea9",
                                            marginTop: "10px",
                                        }}
                                    >
                                        {t(
                                            "DatiSegnalazioneAnagrafici.ulss_di_segnalazione"
                                        )}
                                        <span className={styles.mandatoryColor}>
                                            *
                                        </span>
                                    </p>
                                </div>
                                <div className="col-lg-8">
                                    <div
                                        className={stylesWelcome.fieldContainer}
                                    >
                                        <Autocomplete
                                            id={"idUlssSegnalazione"}
                                            keyField="codice"
                                            descriptionField={"descrizione"}
                                            suggestionField={"descrizione"}
                                            onChange={this.riceviValore}
                                            disabled={
                                                !Utils.isEmpty(
                                                    this.props.segnalazioneCopia
                                                ) ||
                                                (this.state.datiSegnalazione
                                                    .ulssSegnalazione &&
                                                    SessioneUtente.getInstance()
                                                        .ruoliUtente !==
                                                        Ruoli
                                                            .Operatore_Regionale
                                                            .descrizione)
                                                    ? true
                                                    : false
                                            }
                                            field={"ulssSegnalazione"}
                                            value={
                                                this.state.datiSegnalazione
                                                    .ulssSegnalazione
                                            }
                                            placeholder={t(
                                                "DatiSegnalazioneAnagrafici.ulss_di_segnalazione"
                                            )}
                                            suggestions={arrayUlss}
                                        ></Autocomplete>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-7 mt-3">
                            <div className="row">
                                <div className="col-lg-4">
                                    <p
                                        className={styles.labelHeader}
                                        style={{
                                            color: "#1b7ea9",
                                            marginTop: "10px",
                                        }}
                                    >
                                        {t(
                                            "DatiSegnalazioneAnagrafici.Comune_di_segnalazione"
                                        )}
                                        <span className={styles.mandatoryColor}>
                                            *
                                        </span>
                                    </p>
                                </div>
                                <div className="col-lg-8">
                                    <div
                                        className={stylesWelcome.fieldContainer}
                                    >
                                        <Autocomplete
                                            id={"idComuneSegnalazione"}
                                            keyField={"codice"}
                                            descriptionField={"descrizione"}
                                            suggestionField={"descrizione"}
                                            onChange={this.riceviValore}
                                            field={"comuneSegnalazione"}
                                            disabled={
                                                Utils.isEmpty(
                                                    this.props.segnalazioneCopia
                                                ) &&
                                                this.state.datiSegnalazione
                                                    .ulssSegnalazione
                                                    ? false
                                                    : true
                                            }
                                            value={
                                                this.state.datiSegnalazione
                                                    .comuneSegnalazione
                                            }
                                            placeholder={t(
                                                "DatiSegnalazioneAnagrafici.Comune_di_segnalazione"
                                            )}
                                            suggestions={listaComuni}
                                        ></Autocomplete>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        const contactTracing = (
            <div>
                <ContactTracing
                    idSegnalazione={this.props.segnalazioneCopia.idSegnalazione}
                    segnalazioneCopia={this.props.segnalazioneCopia}
                    setStatePadre = {this.setStatePadre}
                    convertiSegnalazione = {(row) => this.convertiInSegnalazione(row)}
                />
            </div>
        );

        const campoObbligatorio = (
            <div className="col-lg-12" style={{ paddingTop: "2rem" }}>
                <div className={styles.mandatoryColor}>
                    {" "}
                    {t("DatiSegnalazioneAnagrafici.campoObbligatorio")}
                </div>
            </div>
        );

        const buttonDiv = (
            <ButtonRow
                nextStep={true}
                onClickConfermaEProsegui={() => this.controlloDatiToaster()}
                isArchiviato={
                    (this.props.segnalazione &&
                        this.props.segnalazione.migrazione) ||
                    SessioneUtente.getInstance().ruoliUtente ===
                        Ruoli.Operatore_Laboratorio.descrizione ||
                    (this.props.segnalazioneCopia &&
                        (this.props.segnalazioneCopia.statoSegnalazione ===
                            OggettiUtili.statoSegnalazioneByLabel.Archiviato
                                .codice ||
                            this.props.segnalazioneCopia.statoValidazione ===
                                OggettiUtili.statoValidazioneByLabel.Validata
                                    .codice))
                }
                modalTextConferma={
                    this.props.segnalazioneCopia.dataSegnalazione
                        ? t("Buttons.confermaModifica")
                        : t("Buttons.messaggioConferma")
                }
                noSalva={true}
                back={this._back}
            />
        );

        const form = (
            <div>
                <div style={{ paddingTop: "1rem" }}>
                    <fieldset
                        disabled={
                            SessioneUtente.getInstance().ruoliUtente ===
                                Ruoli.Operatore_Laboratorio.descrizione ||
                            this.props.segnalazioneCopia.statoSegnalazione ===
                                OggettiUtili.statoSegnalazioneByLabel.Archiviato
                                    .codice ||
                            this.props.segnalazioneCopia.statoValidazione ===
                                OggettiUtili.statoValidazioneByLabel.Validata
                                    .codice
                        }
                    >
                        {datiSegnalazione}
                        <DatiAnagraficiPaziente
                            setDatiPaziente={this.setDatiPaziente}
                            datiPaziente={{
                                nomePaziente: this.props.nomePaziente,
                                cognomePaziente: this.props.cognomePaziente,
                                dataDiNascita:this.props.dataDiNascita,
                                sesso:this.props.sesso &&this.props.sesso=='male'?'M':this.props.sesso &&this.props.sesso=='female'?'F':'',
                                comuneResidenza:this.props.comuneResidenza,
                                indirizzoResidenza: this.props.indirizzoResidenza,
                                comuneDomicilio:this.props.comuneDomicilio,
                                indirizzoDomicilio: this.props.indirizzoDomicilio,
                            }}
                            ulssSegnalazione={
                                this.props.ulssSegnalazione?this.props.ulssSegnalazione:this.state.datiSegnalazione.ulssSegnalazione
                            }
                            setTipoCompilazioneDatiPaziente={
                                this.setTipoCompilazioneDatiPaziente
                            }
                            propsPerDatiPaziente={
                                this.state.propsPerDatiPaziente
                            }
                            codiceFiscale={this.props.codiceFiscale}
                            comuneNascita={this.props.comuneNascita}
                            stp={this.props.stp}
                            dataCompilazione={
                                this.state.datiSegnalazione
                                    .timestampCompilazione
                            }
                            segnalazione={this.props.segnalazione}
                            showSpinner={this.props.showSpinner}
                            segnalazioneModifica={
                                this.props.segnalazioneCopia &&
                                !Utils.isObjectEmpty(
                                    this.props.segnalazioneCopia
                                )
                                    ? this.props.segnalazioneCopia
                                    : ""
                            }
                            isModificaAnagrafe={this.isModificaAnagrafe}
                            isModificaPrevAnagrafe={this.isModificaPrevAnagrafe}
                            idLisSegnalazione={this.props.idLisSegnalazione}
                            formPazienteSpecifico={this.props.formPazienteSpecifico!=undefined?this.props.formPazienteSpecifico:this.state.formPazienteSpecifico}
                        />
                        <TabellaFocolai
                            malattia={this.state.datiSegnalazione.malattia}
                            segnalazione={this.props.segnalazione}
                            setFocolaioSelezionato={this.setFocolaioSelezionato}
                            statoSegnalazione={
                                this.props.segnalazioneCopia
                                    ? this.props.segnalazioneCopia
                                          .statoSegnalazione
                                    : OggettiUtili.statoSegnalazioneByLabel
                                          .Segnalazione.codice
                            }
                            statoValidazione={
                                this.props.segnalazioneCopia
                                    ? this.props.segnalazioneCopia
                                          .statoValidazione
                                    : OggettiUtili.statoValidazioneByLabel[
                                          "Non_Validata"
                                      ].codice
                            }
                            idFocolaioSelezionato={
                                this.props.segnalazioneCopia
                                    ? this.props.segnalazioneCopia.focolai &&
                                      !this.props.segnalazioneCopia
                                          .idSessioneFocolaio
                                        ? this.props.segnalazioneCopia
                                              .focolai[0]
                                        : ""
                                    : ""
                            }
                            idFocolaioPadre={
                                this.props.focolai ? this.props.focolai[0] : null
                            }
                        />

                        {this.state.malattiaContactTracing === "true" ? (
                            contactTracing
                        ) : this.state.malattiaContactTracing?.includes(
                              this.props.malattia ??
                                  this.props.segnalazioneCopia.malattia
                          ) ? (
                            contactTracing
                        ) : (
                            <></>
                        )}

                        <DatiAnagraficiMedico
                            setDatiMedico={this.setDatiMedico}
                            setDatiMedicoCopia={this.setDatiMedicoCopia}
                            inserimentoManuale={true}
                            segnalazione={this.props.segnalazione}
                            segnalazioneModifica={
                                this.props.segnalazioneCopia &&
                                !Utils.isObjectEmpty(
                                    this.props.segnalazioneCopia
                                )
                                    ? this.props.segnalazioneCopia
                                    : ""
                            }
                            dati={this.state.datiMedico}
                        />
                        {campoObbligatorio}
                    </fieldset>
                    {buttonDiv}
                </div>
            </div>
        );

        return (
            <div
                className={
                    (this.props.segnalazione &&
                        this.props.segnalazione.migrazione) ||
                    SessioneUtente.getInstance().ruoliUtente ===
                        Ruoli.Operatore_Laboratorio.descrizione ||
                    this.props.segnalazioneCopia.statoSegnalazione ===
                        OggettiUtili.statoSegnalazioneByLabel.Archiviato
                            .codice ||
                    this.props.segnalazioneCopia.statoValidazione ===
                        OggettiUtili.statoValidazioneByLabel.Validata.codice
                        ? "visualizzazione"
                        : ""
                }
            >
                {ToasterSingleton.instance().renderToaster()}
                {form}
                {this.state.activeFlussoGestioneDuplicati && <GestioneDuplicatiComponent state={this.state} props={this.props} clickKo={() =>this.setState({ activeFlussoGestioneDuplicati: false })}> </GestioneDuplicatiComponent> }
            </div>
        );
    }
}

export default withTranslation("common")(DatiSegnalazioneAnagrafici);
